<template>
  <div class="not-found-container tw-relative tw-flex tw-items-center tw-bg-white tw-py-24 tw-text-center foot-pad">
    <div class="tw-container tw-mx-auto tw-py-32 tw-px-8 lg:tw-px-0 ">
      <div class="lg:tw-flex lg:tw-items-center lg:tw-justify-center">
         <h1 class="" style="font-size:10em;"><strong>404</strong></h1>
          <div class="lg:tw-text-left md:tw-ml-16">
            <h2 class="text-serif tw-leading-snug tw-text-5xl tw-mb-8 lg:tw-mb-6">The page you requested could not be found.</h2>
            <p>
              <RouterLink to="/menu" class="btn btn-primary btn-lg">
                Menu
              </RouterLink>
            </p>
          </div>
      </div>
    </div>

    <span class="tw-absolute tw-bottom-0 loading-scooter-1">
      <svg width="56px" height="37px" viewBox="0 0 56 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>scooter</title>
        <desc>scooter</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
          <g id="icon_delivery" stroke="#080808" stroke-width="1.5">
              <path d="M12.6,35.5 C15.9,35.5 18.6,32.57 18.6,28.95 L6.6,28.95 C6.62,32.57 9.29,35.5 12.6,35.5 Z" id="Path"></path>
              <path d="M12.62,18.17 C8.42,18.17 4.93,21.84 4.13,26.72 C4.02765497,27.1733432 4.12124453,27.6488266 4.38776236,28.0295663 C4.65428019,28.4103061 5.06900914,28.660992 5.53,28.72 L19.7,28.72 C20.1609909,28.660992 20.5757198,28.4103061 20.8422376,28.0295663 C21.1087555,27.6488266 21.202345,27.1733432 21.1,26.72 C20.3,21.84 16.81,18.17 12.62,18.17 Z" id="Path"></path>
              <path d="M20.11,28.73 C20.11,28.73 37.71,31.13 38.92,24.65" id="Path"></path>
              <rect id="Rectangle" x="4.74" y="9.25" width="18.7" height="5.38" rx="1.42"></rect>
              <path d="M5.45,14.63 C4.2490007,16.3663118 2.95372416,18.0354826 1.57,19.63 C-0.23,21.61 1,26 4.3,25.89" id="Path"></path>
              <path d="M23.3,12.91 C23.3,12.91 19.75,24.4 32.43,24.4 C45.11,24.4 34.56,3 33.94,1.31" id="Path"></path>
              <path d="M46.69,20.78 C42.45,20.78 38.93,23.37 38.13,26.78 C37.95,27.52 38.66,28.2 39.53,28.2 L53.84,28.2 C54.71,28.2 55.42,27.52 55.24,26.78 C54.44,23.37 50.92,20.78 46.69,20.78 Z" id="Path"></path>
              <path d="M28.54,4.37 L33.6,1.45" id="Path"></path>
              <path d="M46.62,35 C50.0717748,34.8272556 52.7446269,31.9138468 52.62,28.46 L40.62,28.46 C40.4953731,31.9138468 43.1682252,34.8272556 46.62,35 Z" id="Path"></path>
              <path d="M38.65,0.93 C38.65,0.93 47.65,13.42 45.33,19.86" id="Path"></path>
              <path d="M38.57,0.75 L42.36,1.88" id="Path"></path>
          </g>
        </g>
      </svg>
    </span>

    <span class="tw-absolute tw-bottom-2 loading-scooter-2">
      <svg width="56px" height="37px" viewBox="0 0 56 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>scooter</title>
        <desc>scooter</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
          <g id="icon_delivery" stroke="#999" stroke-width="1.5">
              <path d="M12.6,35.5 C15.9,35.5 18.6,32.57 18.6,28.95 L6.6,28.95 C6.62,32.57 9.29,35.5 12.6,35.5 Z" id="Path"></path>
              <path d="M12.62,18.17 C8.42,18.17 4.93,21.84 4.13,26.72 C4.02765497,27.1733432 4.12124453,27.6488266 4.38776236,28.0295663 C4.65428019,28.4103061 5.06900914,28.660992 5.53,28.72 L19.7,28.72 C20.1609909,28.660992 20.5757198,28.4103061 20.8422376,28.0295663 C21.1087555,27.6488266 21.202345,27.1733432 21.1,26.72 C20.3,21.84 16.81,18.17 12.62,18.17 Z" id="Path"></path>
              <path d="M20.11,28.73 C20.11,28.73 37.71,31.13 38.92,24.65" id="Path"></path>
              <rect id="Rectangle" x="4.74" y="9.25" width="18.7" height="5.38" rx="1.42"></rect>
              <path d="M5.45,14.63 C4.2490007,16.3663118 2.95372416,18.0354826 1.57,19.63 C-0.23,21.61 1,26 4.3,25.89" id="Path"></path>
              <path d="M23.3,12.91 C23.3,12.91 19.75,24.4 32.43,24.4 C45.11,24.4 34.56,3 33.94,1.31" id="Path"></path>
              <path d="M46.69,20.78 C42.45,20.78 38.93,23.37 38.13,26.78 C37.95,27.52 38.66,28.2 39.53,28.2 L53.84,28.2 C54.71,28.2 55.42,27.52 55.24,26.78 C54.44,23.37 50.92,20.78 46.69,20.78 Z" id="Path"></path>
              <path d="M28.54,4.37 L33.6,1.45" id="Path"></path>
              <path d="M46.62,35 C50.0717748,34.8272556 52.7446269,31.9138468 52.62,28.46 L40.62,28.46 C40.4953731,31.9138468 43.1682252,34.8272556 46.62,35 Z" id="Path"></path>
              <path d="M38.65,0.93 C38.65,0.93 47.65,13.42 45.33,19.86" id="Path"></path>
              <path d="M38.57,0.75 L42.36,1.88" id="Path"></path>
          </g>
        </g>
      </svg>
    </span>

    <span class="tw-absolute tw-bottom-4 loading-scooter-3">
      <svg width="56px" height="37px" viewBox="0 0 56 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>scooter</title>
        <desc>scooter</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
          <g id="icon_delivery" stroke="#ccc" stroke-width="1.5">
              <path d="M12.6,35.5 C15.9,35.5 18.6,32.57 18.6,28.95 L6.6,28.95 C6.62,32.57 9.29,35.5 12.6,35.5 Z" id="Path"></path>
              <path d="M12.62,18.17 C8.42,18.17 4.93,21.84 4.13,26.72 C4.02765497,27.1733432 4.12124453,27.6488266 4.38776236,28.0295663 C4.65428019,28.4103061 5.06900914,28.660992 5.53,28.72 L19.7,28.72 C20.1609909,28.660992 20.5757198,28.4103061 20.8422376,28.0295663 C21.1087555,27.6488266 21.202345,27.1733432 21.1,26.72 C20.3,21.84 16.81,18.17 12.62,18.17 Z" id="Path"></path>
              <path d="M20.11,28.73 C20.11,28.73 37.71,31.13 38.92,24.65" id="Path"></path>
              <rect id="Rectangle" x="4.74" y="9.25" width="18.7" height="5.38" rx="1.42"></rect>
              <path d="M5.45,14.63 C4.2490007,16.3663118 2.95372416,18.0354826 1.57,19.63 C-0.23,21.61 1,26 4.3,25.89" id="Path"></path>
              <path d="M23.3,12.91 C23.3,12.91 19.75,24.4 32.43,24.4 C45.11,24.4 34.56,3 33.94,1.31" id="Path"></path>
              <path d="M46.69,20.78 C42.45,20.78 38.93,23.37 38.13,26.78 C37.95,27.52 38.66,28.2 39.53,28.2 L53.84,28.2 C54.71,28.2 55.42,27.52 55.24,26.78 C54.44,23.37 50.92,20.78 46.69,20.78 Z" id="Path"></path>
              <path d="M28.54,4.37 L33.6,1.45" id="Path"></path>
              <path d="M46.62,35 C50.0717748,34.8272556 52.7446269,31.9138468 52.62,28.46 L40.62,28.46 C40.4953731,31.9138468 43.1682252,34.8272556 46.62,35 Z" id="Path"></path>
              <path d="M38.65,0.93 C38.65,0.93 47.65,13.42 45.33,19.86" id="Path"></path>
              <path d="M38.57,0.75 L42.36,1.88" id="Path"></path>
          </g>
        </g>
      </svg>
    </span>

    <span class="tw-absolute tw-bottom-6 loading-scooter-4">
      <svg width="56px" height="37px" viewBox="0 0 56 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>scooter</title>
        <desc>scooter</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
          <g id="icon_delivery" stroke="#ececec" stroke-width="1.5">
              <path d="M12.6,35.5 C15.9,35.5 18.6,32.57 18.6,28.95 L6.6,28.95 C6.62,32.57 9.29,35.5 12.6,35.5 Z" id="Path"></path>
              <path d="M12.62,18.17 C8.42,18.17 4.93,21.84 4.13,26.72 C4.02765497,27.1733432 4.12124453,27.6488266 4.38776236,28.0295663 C4.65428019,28.4103061 5.06900914,28.660992 5.53,28.72 L19.7,28.72 C20.1609909,28.660992 20.5757198,28.4103061 20.8422376,28.0295663 C21.1087555,27.6488266 21.202345,27.1733432 21.1,26.72 C20.3,21.84 16.81,18.17 12.62,18.17 Z" id="Path"></path>
              <path d="M20.11,28.73 C20.11,28.73 37.71,31.13 38.92,24.65" id="Path"></path>
              <rect id="Rectangle" x="4.74" y="9.25" width="18.7" height="5.38" rx="1.42"></rect>
              <path d="M5.45,14.63 C4.2490007,16.3663118 2.95372416,18.0354826 1.57,19.63 C-0.23,21.61 1,26 4.3,25.89" id="Path"></path>
              <path d="M23.3,12.91 C23.3,12.91 19.75,24.4 32.43,24.4 C45.11,24.4 34.56,3 33.94,1.31" id="Path"></path>
              <path d="M46.69,20.78 C42.45,20.78 38.93,23.37 38.13,26.78 C37.95,27.52 38.66,28.2 39.53,28.2 L53.84,28.2 C54.71,28.2 55.42,27.52 55.24,26.78 C54.44,23.37 50.92,20.78 46.69,20.78 Z" id="Path"></path>
              <path d="M28.54,4.37 L33.6,1.45" id="Path"></path>
              <path d="M46.62,35 C50.0717748,34.8272556 52.7446269,31.9138468 52.62,28.46 L40.62,28.46 C40.4953731,31.9138468 43.1682252,34.8272556 46.62,35 Z" id="Path"></path>
              <path d="M38.65,0.93 C38.65,0.93 47.65,13.42 45.33,19.86" id="Path"></path>
              <path d="M38.57,0.75 L42.36,1.88" id="Path"></path>
          </g>
        </g>
      </svg>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'NotFound'
  }
</script>

<style>
.not-found-container {
  min-height: calc(100vh - 10rem);
}

.foot-pad {
  margin-bottom:30px;
}

.loading-scooter-1 {
  left: -62px;
  animation: 5s cubic-bezier(.57,.1,.8,.59) 0s infinite scoot;
  transform: scale(1.3);
  transform-origin: bottom;
  z-index:4;
}

.loading-scooter-2 {
  left: -62px;
  animation: 6s linear 1.16s infinite scoot;
  transform: scale(1.1);
  transform-origin: bottom;
  z-index:3;
}

.loading-scooter-3 {
  left: -62px;
  animation: 9s cubic-bezier(.33,0,.3,.49) 2s infinite scoot;
  z-index:2;
}

.loading-scooter-4 {
  left: -62px;
  animation: 8s ease-in 0.7s infinite scoot;
  transform: scale(0.8);
  transform-origin: bottom;
  z-index:1;
}

@keyframes scoot {
  from {
    left: -62px;
  }

  to {
    left: 100%;
  }
}
</style>